import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";


function TripStatusData(props) {
  const { data } = props;
  console.log("kmmjeijrio",data)
  const navigate = useNavigate();

  let columns;
  {
    data?.map((i, k) => {
      columns = [
        {
          name: "Vehicle Number",
          selector: (i) => i?.regNumber,
        },
        {
          name: "Trip Number",
          selector: (i) => (
            <div
              style={{
                cursor: "pointer",
                textDecorationLine: "underline",
                color: "blue",
              }}
              onClick={() => {
                navigate(`/trips/${i?.tripId}`);
              }}
            >
              {i?.tripNo}
            </div>
          ),
        },
        {
          name: "Trip Start Date",
          selector: (i) => i?.startTime,
        },
      ];
    });
  }
  return (
    <div style={{ margin: "30px 50px 50px 50px" }}>
      <DataTable
        columns={columns}
        data={data}
        customStyles={{
          headRow: {
            style: {
              backgroundColor: "#ededf1",
              fontSize: "16px",
              fontWeight: "bold",
            },
          },
          headCells: {
            style: {
              fontWeight: "bold",
              textTransform: "uppercase",
              border: "1px solid rgba(108, 108, 108, 0.2)",
            },
          },
          cells: {
            style: {
              fontSize: "14px",
              minHeight: "50px",
              border: "1px solid rgba(108, 108, 108, 0.2)",
            },
          },
        }}
        // fixedHeader
        // fixedHeaderScrollHeight='450px'
        // selectableRows
        selectableRowsHighlight
        highlightOnHover
      />
    </div>
  );
}

export default TripStatusData;
